import { Component, Inject, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, OnInit, Input, Injector } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';
import { Status } from '../../models/user-profile';
import { KanbanOfferStore } from '../state/kanban-offer.store';
import { KanbanOfferStoreList } from '../state/kanban-offer-list.store';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { Headers, Http, Response } from '@angular/http';

enum PageType {None, Next, Prev}


@Component({
  selector: 'app-slider-cv',
  templateUrl: './kanban-slider-cv.component.html',
  styleUrls: ['./kanban-slider-cv.component.css']
})
export class KanbanSliderCvComponent implements OnInit, OnDestroy {

  jobInvited: JobsOffer;
  offerList:any;
  currentIndex:number = 0;
  maxIndex:number;
  userId:string;
  job:JobsOffer;
  offerStore: KanbanOfferStore;
  sub: any;
  typecheck:any;
  isreport = false;
  check = false;
  usersSelected: 0;
  type: PageType = PageType.None;
  loading: Observable<boolean>;
  size: Observable<number>;
  @Output() out: EventEmitter<number> = new EventEmitter<number>();



  constructor(public dialogRef: MdDialogRef<KanbanSliderCvComponent>,
              public injector: Injector,
              @Inject(KanbanOfferStoreList) public KanbanOfferStoreList,
              @Inject(MD_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    if (this.data.isreport == "report"){
      this.isreport = true;
    }
      if (this.data.listType == "notrequired"){
        this.offerStore = this.KanbanOfferStoreList.notfullfill;
        this.offerSubscribe();
      }else{
        this.KanbanOfferStoreList.list.forEach(element => {
          if (element.status_ID === this.data.status || (this.data.status === 0 && element.status_ID === 100)){
            this.offerStore = element;
            this.offerSubscribe();
          }
        });
      }
  }

  offerSubscribe(){
    this.size = this.offerStore.offers.map((offers: any[]) => offers.length);
    this.sub = this.offerStore.offers.subscribe(jobs => {
        this.offerList = jobs;
        this.maxIndex = jobs.length;
        if(jobs.length == 0){
          if (!this.check){
            this.check = true;
          }else{
            this.check = false;
            this.dialogRef.close();
          }
        }else{
          this.check = false;
        }

        if(this.type === PageType.None) {
          this.currentIndex = this.data.selected;
        } else if(this.type === PageType.Next) {
          this.currentIndex = 0;
        } else if(this.type === PageType.Prev) {
          this.currentIndex = this.maxIndex - 1;
        }

        if (this.data.jobInvite) {
          this.jobInvited = this.data.jobInvited;
        }
        if (this.offerList[this.currentIndex]){
          this.job = this.offerList[this.currentIndex].job;
          this.userId = this.offerList[this.currentIndex].user.id;
        }else{
          if(jobs.length == 0){
            //this.dialogRef.close();
          }else{
            this.offerList = jobs;
            this.maxIndex = jobs.length;
            this.currentIndex = 0;
            this.job = this.offerList[this.currentIndex].job;
            this.userId = this.offerList[this.currentIndex].user.id;
          }
        }
    });
  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }

  nextCV() {
    this.currentIndex++;
    if(this.currentIndex >= this.maxIndex) {
      this.currentIndex = 0;
      this.type = PageType.Next;
      this.offerStore.nextPage(this.jobInvited);
    } else {
      this.userId = this.offerList[this.currentIndex].user.id;
      this.job = this.offerList[this.currentIndex].job;
    }
  }

  prevCV() {
    this.currentIndex--;
    if(this.currentIndex < 0) {
      this.currentIndex = 0;
      this.type = PageType.Prev
      this.offerStore.prevPage(this.jobInvited);
    } else {
      this.userId = this.offerList[this.currentIndex].user.id;
      this.job = this.offerList[this.currentIndex].job;
    }
  }

  onStatusChanged(event:Status) {
    if (event) {
      if (this.data.status !== event) {
        this.offerList.splice(this.currentIndex, 1);
        this.maxIndex = this.offerList.length;
        this.currentIndex = 0;
        if (this.maxIndex > 0){
          this.userId = this.offerList[this.currentIndex].user.id;
          this.job = this.offerList[this.currentIndex].job;
        }else{
          this.dialogRef.close();
        }
      }
    }
  }

  onFavoriteChanged(event:boolean) {
    this.offerList[this.currentIndex].favorite = event;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/kanban-slider-cv/kanban-slider-cv.component.ts